<template>
  <v-app v-if="isReady">
    <!------------------->
    <!-- Client Toolbar -->
    <!------------------->
    <v-toolbar
      id="headerClient"
      fixed
      app
      clipped
      flat
      dense
      :class="{ 'mobile-toolbar': isMobile }"
      :prominent="isMobile"
    >
      <header-toolbar />
    </v-toolbar>
    <!------------------------>
    <!-- NAVIGATION SIDEBAR -->
    <!------------------------>
    <v-navigation-drawer
      id="sidebar"
      v-model="vdrawer"
      :mini-variant="getWindowWidth >= 1264 ? isMiniSidebar : miniSidebarValue()"
      app
    >
      <header-menu
        :is-mini-sidebar="isMiniSidebar"
        :menu-items="adjustedMenuItems"
        @image-clicked="imageClicked"
      />

      <div v-if="!isMiniSidebar && associatedAgent" class="sidebar-client__agent-details">
        <h5>Your Agent</h5>
        <h2>{{ associatedAgent.name }}</h2>
        <h4>{{ associatedAgent.phone }}</h4>
      </div>
    </v-navigation-drawer>
    <!-- BREADCRUMBS -->
    <v-content :style="{'padding-left' : getLeftPadding}">
      <page-content />
    </v-content>
  </v-app>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import refreshClientData from '../mixins/refreshClientData'
import HeaderToolbar from './HeaderToolbar.vue'
import HeaderMenu from '../common/navigation/HeaderMenu'
import PageContent from './PageContent.vue'
import colors from '../../scss/_colors.scss'

export default {
  components: { HeaderToolbar, HeaderMenu, PageContent },
  mixins: [refreshClientData],
  data() {
    return {
      isReady: false,
      vdrawer: null,
      isMiniSidebar: false,
      tempMenuItems: [
        { text: 'SAVED', link: 'saved' },
        { text: 'PENDING', link: 'pending' },
        { text: 'CONFIRMED', link: 'confirmed' },
        { text: 'SCHEDULED', link: 'scheduled' },
        { text: 'COMPLETED', link: 'completed' }
      ],
      shortMenuItems: [
        { icon: 'search', text: 'SEARCH', link: 'client-search' },
        { icon: 'favorite', text: 'SAVED FAVORITES', link: 'client-favorites' },
        {
          icon: 'message',
          text: 'COMMUNICATION',
          link: 'client-communication'
        },
        { icon: 'calendar_today', text: 'SCHEDULE', link: 'client-schedule' },
        { icon: 'feedback', text: 'FEEDBACK', link: 'client-feedback' },
        // { icon: 'folder_shared', text: 'REFER A FRIEND', link: 'refer-friend' },
        { icon: 'person', text: 'ACCOUNT', link: 'client-account' }
      ],
      fullMenuItems: [
        { icon: 'home', text: 'DASHBOARD', link: 'client-dashboard' },
        { icon: 'search', text: 'SEARCH', link: 'client-search' },
        { icon: 'favorite', text: 'SAVED FAVORITES', link: 'client-favorites' },
        {
          icon: 'message',
          text: 'COMMUNICATION',
          link: 'client-communication'
        },
        { icon: 'calendar_today', text: 'SCHEDULE', link: 'client-schedule' },
        { icon: 'feedback', text: 'FEEDBACK', link: 'client-feedback' },
        { icon: 'person', text: 'ACCOUNT', link: 'client-account' }
        // { icon: 'folder_shared', text: 'REFER A FRIEND', link: 'refer-friend' }
      ],
      colors
    }
  },
  computed: {
    ...mapState('client', ['associatedAgent', 'clientData']),
    ...mapState('home', ['activeRoute']),
    ...mapState('common', [
      'isMobile',
      'drawer'
    ]),

    getWindowWidth() {
      const windowWidth = this.$store.state.home.windowWidth
      return windowWidth
    },

    getLeftPadding() {
      if (this.$store.state.home.windowWidth >= 1264) {
        if (this.isMiniSidebar) return '80px'
        else return '210px'
      } else {
        return '0px'
      }
    },

    adjustedMenuItems() {
      if (this.isMobile) {
        return this.shortMenuItems
      } else {
        return this.fullMenuItems
      }
    }
  },

  watch: {
    activeRoute(newValue, oldValue) {
      if (newValue && newValue.name === 'client-search' && !this.isMiniSidebar) {
        this.isMiniSidebar = true
      }
    },

    drawer() {
      if (this.vdrawer !== this.drawer) {
        this.vdrawer = this.drawer
      }
    },

    vdrawer() {
      if (this.vdrawer !== this.drawer) {
        this.setDrawerState(this.vdrawer)
      }
    }
  },

  async created() {
    await this.getClientData(true)
    if (!this.clientData.homePrefs || !this.clientData.homePrefs.options.length) {
      if (!this.isMobile) {
        this.$router.push({ name: 'client-onboarding' })
      }
    }
    this.isReady = true
    this.setProfileStatus('client')
  },

  methods: {
    /**
     * Mapping mutation to set currently active route
     */
    ...mapActions('common', ['profileLogout']),
    ...mapMutations('common', {
      setProfileStatus: 'SET_PROFILE_STATUS',
      setDrawerState: 'SET_DRAWER_STATE'
    }),

    miniSidebarValue() {
      this.isMiniSidebar = false
      return false
    },

    setReferFriendModalShowing(val) {
      // i - there are more than one component with ref modalMakeOffer, so 'i' helps us find the right one
      this.$refs.modalReferFriend.setModalShowing(val)
    },
    toggleDrawer() {
      this.setDrawerState(!this.drawer)
    },
    imageClicked() {
      if (this.getWindowWidth >= 1264) {
        this.isMiniSidebar = !this.isMiniSidebar
        return
      }
      return this.toggleDrawer()
    }
  }
}
</script>

<style lang="sass" scoped>
// @Toolbar style
.v-content
  background-color: white !important
.toolbar__title
  font-size: $hwayzFont22rem
  color: $hwayzBlack
@media only screen and (max-width: 600px)
  .max-height
    background-color: darkgray
.v-toolbar
    -webkit-box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12)!important
    box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12)!important

// @Sidebar style
#sidebar
  font-weight: 300
  background-color: $hwayzWhite !important
  box-shadow: 3px 1px 5px rgba(0, 0, 0, 0.2)
  max-width: 210px !important
  z-index: 11
.v-list
  padding-bottom: 0 !important

.opacity-zero
  opacity: 0

.opacity-one
  opacity: 1
  transition: all 0.5s ease

.sidebar-active-link, .sidebar-link:hover
  background: $hwayzBrandBlue !important
  .v-list__tile__title
    color: $hwayzWhite !important
    font-size: 12px
    font-family: Roboto,sans-serif
  i
    color: $hwayzWhite !important

.sidebar-client__agent-details
  margin: 6rem 2rem 2rem
  text-align: left
  @media only screen and (max-width: 450px)
    margin: 2rem 2rem 0
  h5
    font-size: 1.6rem
    color: grey
    margin-bottom: 1rem
    font-weight: 400
  h2
    margin-bottom: 0.5rem
    font-size: 1.6rem
    font-weight: 600
  i
    vertical-align: middle
  h4
    font-size: 1.6rem

.hwayzSun
  color: $hwayzSun !important

.layout-content
  @media only screen and (min-width: 600px)
    padding: 2rem 0.5rem
  @media only screen and (min-width: 960px)
    padding: 2rem 1rem

.layout-content--account-page
  padding: 0rem 0rem !important
  background-color: $hwyzHeaderClient
  height: 100%

#headerClient
  box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12) !important
</style>

<style lang="sass">
.application--wrap
  @media only screen and (max-width: 600px)
    min-height: 0 !important
</style>
